import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardHome from "./DashboardHome";
import {
  resolveEntryPointRoute,
  usePlatformContext,
} from "../context/PlatformContext";
import LoadingState from "../components/ui/LoadingState";

export default function DashboardEntry() {
  const navigate = useNavigate();
  const { entryPoint, isLoading } = usePlatformContext();
  const entryPointUsed = (() => {
    try {
      return sessionStorage.getItem("myv_entry_point_used") === "true";
    } catch (error) {
      return false;
    }
  })();

  useEffect(() => {
    if (isLoading) return;
    if (entryPointUsed) return;
    const route = resolveEntryPointRoute(entryPoint);
    if (route && route !== "/dashboard") {
      try {
        sessionStorage.setItem("myv_entry_point_used", "true");
      } catch (error) {
        // no-op
      }
      navigate(route, { replace: true });
    }
  }, [entryPoint, entryPointUsed, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center p-6">
        <div className="w-full max-w-md">
          <LoadingState />
        </div>
      </div>
    );
  }

  return <DashboardHome />;
}
